import moment from 'moment';
import FileSaver from 'file-saver';

export const calculateAge = dob => {
  return moment().diff(dob, 'years', false);
};

/*
 * Method to validate a phone
 * */
export const validatePhone = phone => {
  const reg = /^[6789]\d{9}$/;
  console.log(phone, reg.test(parseInt(phone)));
  return reg.test(parseInt(phone));
};

/*
 * Method to validate an email
 * */
export const validateEmail = email => {
  let reg = /\S+@\S+\.\S+/;
  console.log(email, reg.test(email));
  return reg.test(email);
};

const getFileName = () => {
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  var yyyy = today.getFullYear();

  today = mm + '/' + dd + '/' + yyyy;
  return today;
};

const getRequestStatus = status => {
  if (status < 0) {
    return 'Cancelled';
  } else if (status === 0) {
    return 'Waiting For Confirmation';
  }
  return 'Confirmed';
};

export function writeCsvFile(data) {
  console.log('inside writeCsv ', data);
  const header =
    'RequestId,RequestDate,DoctorName,HospitalName,PatientName,PatientPhone,SponsorName,RelativeName,RelativePhone,Relation,TPA_NAME,ConfirmedAppointmentDate,Slot,NotConfirmedAppointmentDate,OnboardingStatus,RequestStatus,AssignedTo';

  let payload = `${header}\n`;

  data.forEach(o => {
    payload += `${o.consultationId},${o.requestDate},${
      o.name
    },${o.practiceCenter.replace(/,/g, ' ')},${o.userName},${o.userPhone},${
      o.sponsorName
    },${o.relativeName},${o.relativePhone},${o.relation},${o.tpaName},${
      o.confirmedAppointmentDate
    },${o.slot},${o.notConfirmedAppointmentDate},${o.status},${getRequestStatus(
      o.requestStatus,
    )},${o.assignedTo}\n`;
  });

  const blob = new Blob([payload], { type: 'text/csv;charset=utf-8' });
  FileSaver.saveAs(blob, `${getFileName()}.csv`);
}
